const timeFormatter = (seconds: number) => {
	return new Date(seconds * 1000)
		.toISOString()
		.substring(11, 19)
		.replace(/^00:0/i, '');
};

export default timeFormatter;
